angular.module('cfn').directive('cfnInputTimepicker', function() {
  return {
    restrict: 'E',
    scope: {
      model: '=',
      class: '@',
      readonly: '=',
      required: '@',
      change: '&'
    },
    replace: true,
    template:
      '<div class="time-picker-custom">' +
      '<input type="text" cfn-enter-tab  ng-model="hh" style="text-align:right" class="hh part {{class}} time-input" ng-readonly="readonly" ng-required="{{required}}" maxlength="2">' +
      '<div tabindex="-1"  class="seperator part" >:</div>' +
      '<input type="text" cfn-enter-tab  ng-model="mm"  class="mm part {{class}} time-input" ng-readonly="readonly" ng-required="{{required}}"  maxlength="2">' +
      '</div>',
    link: function(scope, element) {
      scope.onChange = function() {
        var date = new Date();
        var hh = parseInt(scope.hh);
        var mm = parseInt(scope.mm);
        if (isNaN(hh)) {
          hh = 0;
        }
        if (isNaN(mm)) {
          mm = 0;
        }
        date.setMinutes(mm);
        date.setHours(hh);
        scopeSet('model', date.getTime());
        // callafter required to have the last change populated
        ang.callAfter(function() {
          scope.change();
        }, scope);
      };

      ang.callAfter(function() {
        $('.hh', element).change(function() {
          ang.apply(scope, function() {
            scope.onChange();
          });
        });
        $('.mm', element).change(function() {
          ang.apply(scope, function() {
            scope.onChange();
          });
        });
      }, scope);

      var scopeSet = function(scopeProperty, val, delayed) {
        if (delayed) {
          scope.$apply(function() {
            scope[scopeProperty] = val;
          });
        } else {
          scope[scopeProperty] = val;
        }
      };

      scope.$watch('model', function() {
        if (scope.model != undefined) {
          var date = new Date(scope.model);
          var minutes = date.getMinutes();
          var hour = date.getHours();
          if (!$('.hh', element).is(':focus')) {
            scopeSet('hh', hour);
          }
          if (!$('.mm', element).is(':focus')) {
            if ((minutes + '').length < 2) {
              minutes = '0' + minutes;
            }
            scopeSet('mm', minutes);
          }
        }
      });
    }
  };
});
